import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Description from '../../component/atom/Description';
import Header from '../../component/atom/Header';
import InputPopup from '../../component/atom/Input/InputPopup';
import InputRadio from '../../component/atom/Input/InputRadio';
import InputText from '../../component/atom/Input/InputText';
import Label from '../../component/atom/Label';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import HospitalBedPopup from '../../popup/HospitalBed';
import SymptomPopup from '../../popup/Symptom';
import TubePopup from '../../popup/Tube';
import { S } from './style';
import { APP } from '../../config/app';
import { CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP, FORM_FIELD_ERROR_FEEDBACK_TEXT, } from '../../config/error';
import { POPUP_TYPE } from '../../config/popup';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/patientInfo'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/patientInfo'].title}/>);
const renderDescription = () => (<Description content='請如實填寫病患狀況，若有不確定的地方可以詢問護理師唷！'/>);
const renderGenderField = ({ gender, genderOptionList, isGenderError, careOrderBabyFormInputFieldRefMap, handleGenderInputChange, }) => (<InputRadio elementRef={careOrderBabyFormInputFieldRefMap.gender} title='性別' radioGroupName='gender' optionList={genderOptionList} refValue={gender || ''} onInputChange={handleGenderInputChange} isError={isGenderError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderHeightField = ({ height, isHeightError, careOrderBabyFormInputFieldRefMap, handleHeightInputChange, }) => (<InputText elementRef={careOrderBabyFormInputFieldRefMap.height} title='身高' placeholder='請輸入' inputType='tel' value={height} maxLength={3} onInputChange={handleHeightInputChange} unit='cm' isError={isHeightError} errMessage={height
        ? FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_NUMBER_RANGE
        : FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderWeightField = ({ weight, isWeightError, careOrderBabyFormInputFieldRefMap, handleWeightInputChange, }) => (<InputText elementRef={careOrderBabyFormInputFieldRefMap.weight} title='體重' placeholder='請輸入' inputType='tel' value={weight} maxLength={3} onInputChange={handleWeightInputChange} unit='kg' isError={isWeightError} errMessage={weight
        ? FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_NUMBER_RANGE
        : FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderAgeField = ({ age, isAgeError, careOrderBabyFormInputFieldRefMap, handleAgeInputChange, }) => (<InputText elementRef={careOrderBabyFormInputFieldRefMap.age} title='年齡' placeholder='請輸入' inputType='tel' value={age} maxLength={3} onInputChange={handleAgeInputChange} unit='歲' isError={isAgeError} errMessage={age
        ? FORM_FIELD_ERROR_FEEDBACK_TEXT.INVALID_NUMBER_RANGE
        : FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderHospitalBedField = ({ hospitalBed, isHospitalBedError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick, }) => (<InputPopup elementRef={careOrderBabyFormInputFieldRefMap.hospitalBed} onInputClick={() => handleInputPopupClick({
        errorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.hospitalBed,
        popup: POPUP_TYPE.HOSPITAL_BED,
    })} title='床位種類' displayValue={hospitalBed || ''} placeHolder='請選擇' isError={isHospitalBedError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderSymptomField = ({ parsedSymptom, isSymptomError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick, }) => (<InputPopup elementRef={careOrderBabyFormInputFieldRefMap.symptom} onInputClick={() => handleInputPopupClick({
        errorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.symptom,
        popup: POPUP_TYPE.SYMPTOM,
    })} title='目前病症' displayValue={parsedSymptom} placeHolder='請選擇' isError={isSymptomError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderTubeField = ({ parsedTube, isTubeError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick, }) => (<InputPopup elementRef={careOrderBabyFormInputFieldRefMap.tube} onInputClick={() => handleInputPopupClick({
        errorType: CARE_ORDER_BABY_FORM_FIELD_ERROR_TYPE_MAP.tube,
        popup: POPUP_TYPE.TUBE,
    })} title='管線' displayValue={parsedTube} placeHolder='請選擇' isError={isTubeError} errMessage={FORM_FIELD_ERROR_FEEDBACK_TEXT.EMPTY_NOT_ALLOWED}/>);
const renderFooter = ({ handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutFooter>
    <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
      上一步
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleForwardButtonClick}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
const renderPopup = ({ popupType, setPopupType, }) => (<>
    <HospitalBedPopup popupType={popupType} setPopupType={setPopupType}/>
    <SymptomPopup popupType={popupType} setPopupType={setPopupType}/>
    <TubePopup popupType={popupType} setPopupType={setPopupType}/>
  </>);
export default function View({ 
// data
isLoading, genderOptionList, gender, height, weight, age, hospitalBed, isGenderError, isHeightError, isWeightError, isAgeError, isHospitalBedError, isSymptomError, isTubeError, careOrderBabyFormInputFieldRefMap, popupType, careOrderBabyFormForPatientInfoPage, 
// func
setPopupType, handleGenderInputChange, handleHeightInputChange, handleWeightInputChange, handleAgeInputChange, handleInputPopupClick, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const description = useMemo(() => renderDescription(), []);
    const popups = useMemo(() => renderPopup({ popupType, setPopupType }), [popupType, setPopupType]);
    const genderField = useMemo(() => renderGenderField({
        gender,
        genderOptionList,
        isGenderError,
        careOrderBabyFormInputFieldRefMap,
        handleGenderInputChange,
    }), [
        gender,
        genderOptionList,
        isGenderError,
        careOrderBabyFormInputFieldRefMap,
        handleGenderInputChange,
    ]);
    const heightField = useMemo(() => renderHeightField({
        height: careOrderBabyFormForPatientInfoPage.height,
        isHeightError,
        careOrderBabyFormInputFieldRefMap,
        handleHeightInputChange,
    }), [height, isHeightError, careOrderBabyFormInputFieldRefMap, handleHeightInputChange]);
    const weightField = useMemo(() => renderWeightField({
        weight: careOrderBabyFormForPatientInfoPage.weight,
        isWeightError,
        careOrderBabyFormInputFieldRefMap,
        handleWeightInputChange,
    }), [weight, isWeightError, careOrderBabyFormInputFieldRefMap, handleWeightInputChange]);
    const ageField = useMemo(() => renderAgeField({
        age: careOrderBabyFormForPatientInfoPage.age,
        isAgeError,
        careOrderBabyFormInputFieldRefMap,
        handleAgeInputChange,
    }), [age, isAgeError, careOrderBabyFormInputFieldRefMap, handleAgeInputChange]);
    const hospitalBedField = useMemo(() => renderHospitalBedField({
        hospitalBed,
        isHospitalBedError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    }), [hospitalBed, isHospitalBedError, careOrderBabyFormInputFieldRefMap, handleInputPopupClick]);
    const symptomField = useMemo(() => renderSymptomField({
        parsedSymptom: careOrderBabyFormForPatientInfoPage.parsedSymptom,
        isSymptomError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    }), [
        careOrderBabyFormForPatientInfoPage.parsedSymptom,
        isSymptomError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    ]);
    const tubeField = useMemo(() => renderTubeField({
        parsedTube: careOrderBabyFormForPatientInfoPage.parsedTube,
        isTubeError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    }), [
        careOrderBabyFormForPatientInfoPage.parsedTube,
        isTubeError,
        careOrderBabyFormInputFieldRefMap,
        handleInputPopupClick,
    ]);
    const footer = useMemo(() => renderFooter({ handleBackButtonClick, handleForwardButtonClick }), [handleBackButtonClick, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {popups}
      {header}
      <S.Layout>
        {description}
        <S.LayoutInputFields>
          <Label title='病患基本資料'/>
          {genderField}
          {heightField}
          {weightField}
          {ageField}
          {hospitalBedField}
        </S.LayoutInputFields>
        <S.LayoutInputFields>
          <Label title='病患狀況'/>
          {symptomField}
          {tubeField}
        </S.LayoutInputFields>
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
